import { AbstractControl, ValidationErrors } from '@angular/forms';

export function dateTodayOrAfterValidator(control: AbstractControl): ValidationErrors | null {
	if (control.value) {
		const regex = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
		const result = regex.exec(control.value);

		if (!result) {
			return {
				dateAfter: true,
			};
		}

		const [_, day, month, year] = result;

		const date = new Date(+year, +month - 1, +day);

		const after = new Date();
		after.setHours(23, 59, 59, 999);
		after.setDate(after.getDate() - 1);

		if (date < after) {
			return {
				dateAfter: true,
			};
		}
	}

	return null;
}
